/**
 * Dev Mode Banner
 *
 * Displays a warning banner when the app is running without Clerk authentication.
 * This allows development without API keys while making it clear auth is disabled.
 */

export function DevModeBanner() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#f59e0b',
      color: '#000',
      padding: '8px 16px',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 'bold',
      zIndex: 9999,
      fontFamily: 'var(--font-family-mono, monospace)',
    }}>
      Development Mode: Authentication is disabled. Set VITE_CLERK_PUBLISHABLE_KEY to enable auth.
    </div>
  );
}
